import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "grid gap-6 grid-cols-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-black-lp-300 mt-1"
}
const _hoisted_3 = { class: "w-2/12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_5 = { class: "flex items-end justify-between" }
const _hoisted_6 = { class: "flex gap-x-16" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Total STT ", -1)
const _hoisted_9 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_10 = { class: "space-y-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Total Koli ", -1)
const _hoisted_12 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Total Gross Weight ", -1)
const _hoisted_15 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_16 = { class: "space-y-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Total Volume Weight ", -1)
const _hoisted_18 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_19 = { class: "flex gap-x-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_21 = { class: "relative" }
const _hoisted_22 = { class: "flex-col grid col-gap-2 grid-cols-8 justify-center w-full mt-2" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_24 = { class: "col-span-4 space-y-1" }
const _hoisted_25 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_27 = { class: "text-12px text-black-lp-300" }
const _hoisted_28 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_30 = { class: "text-12px text-black-lp-300" }
const _hoisted_31 = { class: "flex flex-row" }
const _hoisted_32 = { class: "flex flex-col space-y-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "text-20px font-semibold text-black-lp-200" }, " Hapus Barang ", -1)
const _hoisted_34 = { class: "space-y-1" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }, [
  /*#__PURE__*/_createTextVNode(" Masukan No. STT atau Scan Barcode/QR Code "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" yang ingin dihapus dari daftar STI-SC. ")
], -1)
const _hoisted_36 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-600 text-12px xxl:text-14px" }, "Terhapus", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "check-circle"
}, null, -1)
const _hoisted_39 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_40 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: "Update STI-SC",
      "vertical-separator": false,
      "is-floating-action": true,
      fullPage: ""
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: "Nama Partner",
            class: "col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.dataProfile.account_type_detail.company_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataProfile.account_type_detail.company_name = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Tipe User",
            class: "col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.typeUser,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.typeUser = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Tanggal STI-SC",
            class: "col-span-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Datepicker, {
                class: "mt-1.5",
                disabled: "",
                modelValue: _ctx.stiScDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.stiScDate = $event)),
                placeholder: "Pilih atau masukkan No. seri kendaraan"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            class: "col-span-4",
            label: "No. STT"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                ref: "inputStt",
                onEnter: _ctx.onValidateSttNumber,
                onChange: _ctx.onChangeInputStt,
                sizeInput: "24px",
                labelStacked: "Contoh : 99LP1234567890123/88-22-12345678",
                modelValue: _ctx.form.sttNumber,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.sttNumber = $event)),
                placeholder: "Masukan No. STT atau Scan Barcode/QR Code",
                bold: !!_ctx.form.sttNumber
              }, null, 8, ["onEnter", "onChange", "modelValue", "bold"]),
              (!_ctx.isPaid)
                ? (_openBlock(), _createBlock("p", _hoisted_2, " *Terjadi kelebihan berat sehingga customers perlu menyelesaikan tagihan kurang bayar "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onAddSttNumber,
            customClass: "px-12 py-2.5",
            title: "Tambah",
            textColor: "white",
            disabled: _ctx.isDisableAddSttNumber
          }, null, 8, ["onClick", "disabled"])
        ]),
        (_ctx.dataSttToBeUpdate.length > 0)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.totalStt), 1)
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.totalPieces), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeight)), 1)
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatWeight(_ctx.totalVolumeWeight)), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_LpButton, {
                    outline: "",
                    iconLeft: "delete",
                    title: "Hapus",
                    onClick: _ctx.onShowDelete,
                    textColor: "red-lp-300"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_LpButton, {
                    onClick: _ctx.togglePanel,
                    icon: 
                _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
              ,
                    title: "Process",
                    textColor: "white"
                  }, null, 8, ["onClick", "icon"]),
                  _createVNode(_component_OverlayPanel, {
                    ref: "op",
                    appendTo: "body",
                    style: {"width":"auto"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LpButton, {
                        class: "w-60",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pickupAndPrint(false))),
                        flat: "",
                        dense: "",
                        iconLeft: "sti-sc",
                        title: "Update STI-SC"
                      }),
                      _hoisted_20,
                      _createVNode(_component_LpButton, {
                        class: "w-full",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pickupAndPrint(true))),
                        flat: "",
                        dense: "",
                        iconLeft: "printer",
                        title: "Update STI-SC & Print PDF"
                      })
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode(_component_TableV2, {
                  data: _ctx.dataSttToBeUpdate,
                  columns: _ctx.columns,
                  borderTop: false,
                  pagination: _ctx.pagination,
                  "is-hard-pagination": true,
                  "is-quick-search": true,
                  "is-sorting": true,
                  "pagination-style": "v2",
                  autoHeight: "",
                  isPinnedScrollBottom: false
                }, null, 8, ["data", "columns", "pagination"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onBack"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.alertPopup.message,
      image: _ctx.alertPopup.image,
      textSuccess: _ctx.isPartial || _ctx.isFailed ? 'Download' : 'OK',
      textCancel: _ctx.isPartial || _ctx.isFailed ? 'OK' : '',
      class: "px-8",
      customButton: _ctx.isPartial || _ctx.isFailed ? 'px-10' : 'px-6'
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("div", _hoisted_24, [
            _withDirectives(_createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.countSuccess) + " No. STT Sukses ", 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.countFailed) + " No. STT Gagal ", 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, _ctx.openSuccess || _ctx.isErrorTyping || _ctx.isFailed || _ctx.isPartial]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: "Konfirmasi Pembuatan",
      message: `Pastikan kembali, seluruh detail STT sudah benar dan sesuai.`,
      image: "are-you-sure",
      textSuccess: "Process",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _createVNode(_component_Notification, {
      data: _ctx.detailSttNotification,
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.notification = $event))
    }, null, 8, ["data", "modelValue"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true,
      onReset: _ctx.onCloseDelete
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_31, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "delete"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_LpInput, {
                error: !!_ctx.errorSttNumberDelete,
                errorCaption: _ctx.errorSttNumberDelete,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.sttNumberToDelete = $event)),
                onEnter: _ctx.onDeleteSttNumber
              }, null, 8, ["error", "errorCaption", "modelValue", "onEnter"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_36, [
                  _hoisted_37,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_38,
                      _createVNode("div", _hoisted_39, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode(_component_LpButton, {
            onClick: _ctx.onCloseDelete,
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: "Batal",
            class: "mt-10"
          }, null, 8, ["onClick"]),
          _createVNode(_component_LpButton, {
            disabled: !_ctx.sttNumberToDelete,
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: "Hapus",
            class: "mt-10"
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onReset"]),
    _createVNode("img", {
      id: "logo",
      src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"])
  ], 64))
}